<style lang="scss" scoped>
.icon-selector {
	ul {
		list-style: none;
		overflow: hidden;
	}
	li {
		float: left;
		margin-right: 7px;
		margin-bottom: 7px;
	}
	img {
		width: 65px;
		border: 3px solid transparent;
		cursor: pointer;
		&:hover {
			background: #ddd;
			border-radius: 4px;
		}
		&.\--chosen {
			border: 3px solid red;
			border-radius: 50%;
		}
	}
	&__file-upload {
		border: 1px dashed #dcdfe6;
		height: 100px;
		width: 100%;
		font-size: 20px;
		text-align: center;
		color: darken(#dcdfe6, 15);
		line-height: 100px;
		border-radius: 5px;
		&:hover {
			border-color: #c0c4cc;
		}
	}
	& /deep/ .croppie-container {
		margin-top: 10px;
		margin-bottom: -60px;
		.cr-boundary {
			margin-left: 0;
			border-radius: 10px;
			height: 400px;
			width: 400px;
		}
		.cr-slider-wrap {
			margin-left: 0;
			text-align: left;
		}
	}
	.is-error {
		.file-upload {
			border: 1px solid #ff4949;
		}
	}
}
</style>


<template lang="pug">
    layout-modal.icon-selector
        ul
            li(v-for="icon in preFabIcons")
                img(:src="`/static/img/icon-sets/bespoke/${icon}.png`", @click="selectPreFabIcon(icon)", :class="{ '--chosen' : icon === icon.value }")
</template>

<script>
export default {
	props: {
		icon: {
			type: Object,
			default: () => ({
				type: null,
				value: null
			})
		}
	},
	data() {
		return {
			preFabIcons: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24]
		};
	},
	methods: {
		selectPreFabIcon(icon) {
			this.$vuedals.close({
				type: "icon",
				value: `${icon}`
			});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/classroom/create/AvatarSelector/Icons.vue